export {
  default as HeroImageProvider,
  useHeroImageContext,
} from './hero-image-provider';
